/**
 * Created by Claude on 08.03.2026
 */

const IslandPreviewItem = function (item, logic) {
    const bundle = IslandDecorationHelper.getPreviewBundle(logic.period);

    return Prefab.instantiate(bundle.jsons.island_preview_item_prefab_json, { item, logic });
};

IslandPreviewItem.TOTAL_DURATION = 6;
IslandPreviewItem.GLOW_DURATION = 0.5;
